module.exports = __webpack_public_path__ + "img/52-l.08b16c41.png";